var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tooltip',{ref:"tooltip",attrs:{"disabled":_vm.disabled,"top":_vm.top,"bottom":_vm.bottom,"close-delay":_vm.closeDelay,"open-delay":_vm.openDelay,"max-width":_vm.maxWidth,"content-class":_vm.contentClass,"open-on-hover":!_vm.isTouchSupported,"open-on-click":false,"open-on-focus":false},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_vm._t("activator",null,{"on":{
        ...on,
        click: _vm.onClickActivator,
      },"attrs":attrs})]}}],null,true)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }